module.exports = __webpack_public_path__ + "static/the-third-chimpanzee-ded64300e55104816c61a07838cdf6f4.jpg";